import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-long-beach')!;
const LongBeachPage = () => <CityLandingPage data={data} />;
export default LongBeachPage;
